export default __webpack_public_path__ + "static/MoblieAD-26ecaa6dbfc144880d8969adf361affc.webm";